import Accounting from '../../mixins/accounting';
import ProductDetailsSimplified from './ProductDetailsSimplified';

export default {
    name: 'product-details',

    props: ['product', 'currencyIsChanging', 'showTermsAndConditions', 'upsellCardType', 'vehicle'],

    mixins: [Accounting],

    components: {ProductDetailsSimplified},

    template: `
        <product-details-simplified
            :upsellCardType="upsellCardType"
            :currencyIsChanging="currencyIsChanging"
            :showTermsAndConditions="showTermsAndConditions"
            :product="product"
            :vehicle="vehicle"
        >
        </product-details-simplified>
    `,
}
